// SoleProprietorshipRegistration.jsx
import React from "react";

export default function SoleProprietorshipRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Sole Proprietorship Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Sole Proprietorship
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Sole Proprietorship Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks helps individuals register Sole Proprietorships
            with proper legal recognition and regulatory compliance. The
            advisory team ensures that your business identity and operations are
            aligned with applicable laws and documentation requirements.
          </p>
          <p className="text-gray-700">
            From selecting the appropriate registrations (such as GST, Shop and
            Establishment, or UDYAM) to organizing key documents, Hawkins
            &amp; Brooks simplifies the process so you can start and run your
            business with confidence.
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Consultation for sole proprietorship registration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Sole Proprietorship Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks guides you through compiling and validating
              all supporting documents, helping avoid delays and ensuring
              trouble-free registration of your proprietorship.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of the proprietor</li>
                <li>Identity proof (Aadhaar, Passport, Voter ID, etc.)</li>
                <li>Residential address proof of proprietor</li>
                <li>
                  Business address proof (rent agreement, utility bill, shop
                  establishment proof, etc.)
                </li>
                <li>Recent passport-size photograph of proprietor</li>
                <li>
                  Additional registration-specific documents (GST, UDYAM, etc.),
                  if applicable
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks offers focused support tailored for small and
              individual businesses, making proprietorship registration smooth
              and hassle-free.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Simple &amp; Quick Compliance Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Streamlined guidance for choosing the right registrations,
                  filling forms, and submitting applications with minimal
                  complexity and quick turnaround.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Clear Documentation Guidance
                </h3>
                <p className="text-gray-700 text-sm">
                  Step-by-step support on what documents are required, how to
                  prepare them, and how to ensure they meet regulatory
                  standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  Experienced professionals offering reliable advice, responsive
                  communication, and continued support even after registration
                  is complete.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
